"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaterQualityColor = exports.WaterQualityThreshold = void 0;
var WaterQualityThreshold;
(function (WaterQualityThreshold) {
    WaterQualityThreshold[WaterQualityThreshold["excellent"] = 250] = "excellent";
    WaterQualityThreshold[WaterQualityThreshold["good"] = 750] = "good";
    WaterQualityThreshold[WaterQualityThreshold["fair"] = 1500] = "fair";
    WaterQualityThreshold[WaterQualityThreshold["poor"] = 3000] = "poor";
    WaterQualityThreshold[WaterQualityThreshold["veryPoor"] = 10000] = "veryPoor";
})(WaterQualityThreshold = exports.WaterQualityThreshold || (exports.WaterQualityThreshold = {}));
var WaterQualityColor;
(function (WaterQualityColor) {
    WaterQualityColor["Red"] = "red";
    WaterQualityColor["Yellow"] = "yellow";
    WaterQualityColor["Blue"] = "blue";
})(WaterQualityColor = exports.WaterQualityColor || (exports.WaterQualityColor = {}));
